<h2><span i18n="@@titleChargeScheduleSettings">Charge Schedule Settings</span>&nbsp;<span i18n="@@Charger">Charger</span> {{ chargerId }}</h2>

@let chargerSetting = chargerSettings();
@if (chargerSettingsLoaded() && (chargerSetting)) {

	<div class="card-container">
		<mat-card class="mat-elevation-z5">
			<mat-card-content>
				<mat-list>
					<mat-list-item>
						<div class="item-block">
							<div class="line-top" i18n="@@Enabled">Enabled</div>
							<div class="title-bottom">
								<app-property
									[id]="'enabled'"
									[type]="'boolean'"
									[(value)]="chargerSetting.enabled"
									[saveCallback]="saveCallback"
								/>
							</div>
						</div>
					</mat-list-item>

					<mat-list-item>
						<div class="item-block">
							<div class="line-top" i18n="@@RandomizedTimeOffsetEnabled">Randomized Time Offset Enabled</div>
							<div class="title-bottom">
								<app-property 
									[id]="'randomizedTimeOffsetEnabled'"
									[type]="'boolean'"
									[value]="chargerSetting.randomizedTimeOffsetEnabled"
									[saveCallback]="saveCallback"
								/>
							</div>
						</div>
					</mat-list-item>

					@if (chargerSetting.enabled.value) {
						
						@if (chargerSetting && ('scheduleType' in chargerSetting)) {
							<mat-list-item>
								<div class="item-block">
									<div class="line-top" i18n="@@ScheduleType">Schedule Type</div>
									<div class="title-bottom">
										<app-property 
											[id]="'scheduleType'"
											[type]="'string'"
											[(value)]="chargerSetting.scheduleType"
											[saveCallback]="saveCallback"
										/>
									</div>
								</div>
							</mat-list-item>
						}

						@if (chargerSetting.scheduleType.value === 'DelayedStart') {
							<mat-list-item>
								<div class="item-block">
									<div class="line-top" i18n="@@DelayedStart">Delayed Start</div>
									<div class="title-bottom">
										<app-property 
											[id]="'delayedStart'"
											[type]="'DelayedStart'"
											[value]="chargerSettings()?.delayedStart"
											[saveCallback]="saveCallback"
										/>
									</div>
								</div>
							</mat-list-item>
						}
					}
				</mat-list>
			</mat-card-content>
		</mat-card>
	</div>
	@if ((chargerSetting.enabled.value) && (chargerSetting.scheduleType.value === 'WeekSchedule')) {
		@let weekSchedule = chargerSetting.weekSchedule;
		@if (weekSchedule) {
			<div class="card-container">
				@for (day of days; track day) {
					<mat-card class="mat-elevation-z5">
						<mat-card-header>
							<mat-card-title>{{ day | titlecase }}</mat-card-title>
						</mat-card-header>
						<mat-card-content>
							<app-property 
								[id]="'weekSchedule.' + day"
								[type]="'DaySchedule'"
								[value]="weekSchedule[day]"
								[metadata]="{isChangeAllowed: chargerSetting.weekSchedule.isChangeAllowed || false, allowedValues: chargerSetting.weekSchedule.chargingMode.allowedValues || []}"
								[saveCallback]="saveCallback"
							/>
						</mat-card-content>
					</mat-card>
				}
			</div>
		}
	}

} @else {
	<mat-spinner />
}
